// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';

import { withPageMeta } from '@gandi/app-runner';
import { withTranslator } from '@gandi/translate';

import { withRouter } from 'src/helpers/withRouter';

import { fetchCorporatePackMonthlyPrices } from '../modules/app/actions';

import type { FullState, Dispatch } from '../types';

import Presenter, { type StateProps } from './components/Presenter';
import {
  validateSearch,
  resetAllResults,
  resetSearch,
} from './modules/actions';
import { selectHasResults, selectHasCorporateTLDs } from './modules/selectors';

const mapStateToProps = (state: FullState): StateProps => ({
  hasCorporateTLDs: selectHasCorporateTLDs(state),
  hasResults: selectHasResults(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  validateSearch: (...args: any) => dispatch(validateSearch(...args)),
  fetchCorporatePackMonthlyPrices: (...args: any) =>
    dispatch(fetchCorporatePackMonthlyPrices(...args)),
  resetAllResults: () => dispatch(resetAllResults()),
  resetSearch: () => dispatch(resetSearch()),
});

export default (compose(
  withTranslator({ propsNamespace: 'translator' }),
  withPageMeta(args => ({
    title: args.__('Domain name transfer - Gandi.net'),
    description: args.__(
      'Domain names - One of the largest catalogs of new TLDs, with free mailboxes and SSL certificate.',
    ),
  })),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(Presenter): React.ComponentType<{}>);
